import React from "react";
import grillImg from "../../assets/images/bestSellerImg.png";
import bestsellerhd from "../../assets/images/Best Seller.png";
import bg from "../../assets/images/bestBg.png";
import { useNavigate } from "react-router-dom";
const BestSeller = () => {
  const history = useNavigate();
  return (
    <section id="best-seller">
      <div className="best-seller-container">
        <div className="best-seller-image">
          <img src={grillImg} alt="Best Seller" />
        </div>

        <div className="best-seller-content">
          <img src={bg} alt="Best Seller" className="bg-content" />
          <div className="details">
            <span className="tag">
              <img src={bestsellerhd} alt="Best Seller" className="tag-img" />
            </span>

            <h2>
              SINK YOUR TEETH INTO OUR <br />
              Mozzarella-Stuffed Grilled Cheese
            </h2>
            <p>
              Try the Gilman Grilled Cheese, our crispy, buttery grilled cheese stuffed with gooey mozzarella sticks and served with chips,
              pickle and marinara for dipping.
            </p>
            <button className="order-btn" onClick={() => history("/menu?section=extras&item=gilmangrilledcheese")}>
              ORDER THE GOODNESS
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BestSeller;
